import { JSX, useRef } from 'react';

import { usePublicConfigurationContext } from '../../app/PublicConfigurationContext';
import { GoogleLoginSuccessCallback, useGoogleLoginIFrameEventListener } from './useGoogleLoginIFrameEventListener';

type Props = {
    successCallback: GoogleLoginSuccessCallback;
};

export function GoogleLoginOneTouchButton({ successCallback }: Props): JSX.Element {
    const ref = useRef<HTMLIFrameElement>(null);
    const { googleClientId } = usePublicConfigurationContext();
    useGoogleLoginIFrameEventListener(ref, googleClientId, successCallback);

    return (
        <iframe
            ref={ref}
            className="overflow-hidden w-[240px] h-[50px] border-0"
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            src={`/google-login-iframe.html?o=${encodeURIComponent(window.location.origin)}`}
        />
    );
}
